<div class="pdf-viewer-container" 
     role="document" 
     [attr.aria-label]="'PDF viewer: ' + title"
     tabindex="-1"
     #pdfContainer>
  <div class="sr-only" aria-live="polite" aria-atomic="true">
    {{ loadingMessage }}
  </div>
  <ngx-extended-pdf-viewer
    *ngIf="pdfUrl"
    [src]="pdfUrl"
    [language]="currentLanguage"
    [useBrowserLocale]="false"
    [textLayer]="true"
    [showHandToolButton]="true"
    [height]="'75vh'"
    [showDownloadButton]="true"
    [showPrintButton]="true"
    [showOpenFileButton]="false"
    [showBookmarkButton]="true"
    [showPresentationModeButton]="false"
    [showRotateButton]="true"
    [showSidebarButton]="true"
    [zoom]="'auto'"
    [httpHeaders]="httpHeaders"
    (pdfLoaded)="onPdfLoaded()"
    (pdfLoadingFailed)="onPdfLoadingFailed($event)"
    [attr.aria-label]="title">
  </ngx-extended-pdf-viewer>
  <div *ngIf="loadError" 
       class="error-message" 
       role="alert" 
       aria-live="assertive">
    <p>{{ loadError }}</p>
  </div>
</div>
